import { BrainCircuit, ArrowRight } from "lucide-react";
import { motion } from "motion/react";

export default function IntroScreen({ onStart }: { onStart: () => void }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -16 }}
      className="max-w-xl mx-auto text-center"
    >
      <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-violet-600 to-purple-600 flex items-center justify-center mx-auto mb-6 shadow-xl shadow-violet-500/25">
        <BrainCircuit className="w-9 h-9 text-white" />
      </div>
      <h1
        className="text-[32px] lg:text-[40px] text-slate-900 tracking-tight mb-3"
        style={{ fontWeight: 900 }}
      >
        Career Personality Test
      </h1>
      <p
        className="text-[15px] text-slate-500 leading-relaxed mb-8 max-w-md mx-auto"
        style={{ fontWeight: 400 }}
      >
        Discover which university fields and careers suit you best — based on
        the RIASEC model, the world's most trusted career interest framework.
      </p>

      <div className="grid grid-cols-3 gap-3 mb-8">
        {[
          { icon: "🕐", label: "5 minutes", sub: "30 quick questions" },
          { icon: "🎯", label: "Personalised", sub: "Based on your interests" },
          { icon: "🎓", label: "Free", sub: "Know your potential" },
        ].map((s, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl border border-slate-100 p-4 shadow-sm"
          >
            <p className="text-[24px] mb-1">{s.icon}</p>
            <p
              className="text-[13px] text-slate-900"
              style={{ fontWeight: 700 }}
            >
              {s.label}
            </p>
            <p
              className="text-[11px] text-slate-400"
              style={{ fontWeight: 400 }}
            >
              {s.sub}
            </p>
          </div>
        ))}
      </div>

      <button
        onClick={onStart}
        className="flex items-center gap-2 px-8 py-4 rounded-2xl bg-gradient-to-r from-violet-600 to-purple-600 text-white text-[15px] mx-auto shadow-xl shadow-violet-500/25 hover:shadow-violet-500/40 hover:-translate-y-0.5 transition-all"
        style={{ fontWeight: 700 }}
      >
        Start the Test <ArrowRight className="w-5 h-5" />
      </button>

      <p
        className="text-[12px] text-slate-400 mt-4"
        style={{ fontWeight: 400 }}
      >
        Based on Holland's RIASEC theory · Used by universities worldwide
      </p>
    </motion.div>
  );
}
